import { Component, ViewChild, OnInit } from '@angular/core';
import { PagePreloaderComponent } from '../';

@Component({
    selector: 'app-page',
    styles: [`        
        .app-page {
            padding-top: 70px;
            position: relative;
            overflow: auto;
            height: 100%;

            .mobile-page-content {
                height: 100%;
                overflow: auto;
            }
        }
    `],
    template: `
        <div class="app-page h-100">
            <page-preloader></page-preloader>
            <ng-content></ng-content>
        </div>
    `
})
export class AppPageComponent implements OnInit {
    @ViewChild(PagePreloaderComponent) preloader;

    ngOnInit() {
        this.activatePreloader();
    }

    activatePreloader() {
        this.preloader.show();
    }

    deactivatePreloader() {
        this.preloader.hide();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/app-page/app-page.component.ts